import apiCrud from '../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/staffs/partner-staff-board-members`;
export const modelName = 'partner-staff-board-member';

export default {
  ...apiCrud({ baseUri, modelName }),
};
